import GenericTextField from "src/components/GenericTextField";
import { Autocomplete, Checkbox, CircularProgress } from "@mui/material";
import { useEffect, useState, Fragment } from "react";
import { buscarComboPorCodigo } from "src/services/api-autenticacao.service";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

function GenericTextIdAutoCompleteSelect(props) {
  const {
    codigoCombo,
    label,
    placeholder,
    value,
    replaceId = "id",
    replaceLabel = "label",
    required,
    onChange,
    error,
    helperText,
    inputRef,
    selectAllItem,
    multiple,
    noOptionsText,
    variant,
    ...rest
  } = props;

  const [open, setOpen] = useState(false);
  const [emptyListReturn, setEmptyListReturn] = useState(false);
  const [selectedValue, setSelectedValue] = useState(!!multiple ? [] : {});
  const [options, setOptions] = useState([]);
  const loading = true && options.length === 0 && !emptyListReturn;
  const adjustOption = (option) => {
    let opt = {};
    opt[replaceId] = option.id;
    opt[replaceLabel] = option.label;
    if (option.selectAll) opt['selectAll'] = true;
    return opt;
  };

  const loadOptions = async (forceReload = false) => {
    let active = true;
    if (
      (!loading && !forceReload) ||
      codigoCombo == null ||
      (typeof codigoCombo === "string" && codigoCombo.trim() === "")
    ) {
      return undefined;
    }
    (async () => {
      try {
        setEmptyListReturn(false);
        const response = await buscarComboPorCodigo(codigoCombo);
        const optionsList = await response.detalhes.itensCombo.map((item) => {
          const splitValues = item.split("/|/");
          return adjustOption({
            id: splitValues[0],
            label: splitValues[1],
          });
        });
        if (selectAllItem) {
          optionsList.unshift(
            adjustOption({
              id: undefined,
              label: 'Selecionar todos',
              selectAll: true
            })
          );
        }
        if (active) setOptions(optionsList);
        if (optionsList.length === 0) setEmptyListReturn(true);
      } catch (err) {
        console.log(err);
      }
    })();
    return () => {
      active = false;
    };
  };

  useEffect(() => {
    loadOptions(true);
  }, [codigoCombo]);

  useEffect(() => {
    loadOptions();
  }, [loading]);

  useEffect(() => {
    let valueOf = value;

    if (typeof valueOf === "string") {
      valueOf = parseInt(value);
    }

    !!multiple
      ? setSelectedValue(
          options.filter((option) =>
            valueOf.some((val) => val[replaceId] === option[replaceId])
          )
        )
      : setSelectedValue(
          options.filter((option) => option[replaceId] === valueOf)[0] || {}
        );
  }, [options, value]);


  const getOptionKey = (option) => {
    if (!option || Object.keys(option).length === 0) return undefined;
    else return option[replaceId];
  };

  const getOptionLabel = (option) => {
    if (!option || Object.keys(option).length === 0) return "";
    else return option[replaceLabel];
  };

  const isOptionEqualToValue = (option, value) => {
    if (!value) return false;
    return option[replaceId] === value[replaceId];
  };

  const handleChange = (event, newValue) => {
    if (!multiple) {
      onChange(getOptionKey(newValue));
    } else {
      for(const newVal of newValue) {
        if (newVal.selectAll) {
          console.log(newVal);
          console.log(newValue);
          setSelectedValue(options.filter(opt=>opt[replaceId]!=null));
          return;
        }
      }
      onChange(newValue);
    }
  };


  return (
    <Autocomplete
      {...rest}
      size={"small"}
      required={required}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      isOptionEqualToValue={isOptionEqualToValue}
      getOptionKey={getOptionKey}
      getOptionLabel={getOptionLabel}
      options={options}
      loading={loading}
      noOptionsText={noOptionsText || "Sem opções!"}
      onChange={handleChange}
      value={selectedValue}
      renderOption={(props, option, { selected }) => (
        <div> {
          (!option.selectAll || (selectedValue.length !== (options.length - 1))) &&
          <li {...props} 
            key={option[replaceId]}
            style={{
              margin: "0px",
              padding: "4px"
            }}
          >
            {(!!multiple && !option.selectAll) && (
              <Checkbox
                size={"small"}
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{
                  margin: "0px",
                  padding: "0px",
                }}
                checked={selected}
              />
            )}
            { (!option.selectAll || (selectedValue.length !== (options.length - 1))) &&
              <span style={{ marginLeft: "8px",fontSize: "14px" }}>{option[replaceLabel]}</span>
            }
          </li>
        }
        </div>
      )}
      renderInput={(params) => (
        <GenericTextField
          label={(label)
            ? label.concat(required ? " *" : "")
            : undefined
          }
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          variant={variant}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
          {...params}
        />
      )}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      ref={inputRef}
    />
  );
}

export default GenericTextIdAutoCompleteSelect;
